import { HerJourneyHubHeroSection, HerJourneyHubCardsSection } from '@/components/sections'

export const HerJourneyHubPage = () => (
  <main>
    <HerJourneyHubHeroSection />
    <HerJourneyHubCardsSection />
  </main>
)
